/** Sidebar gradient - overridden per theme via CSS custom property. */

export const SIDEBAR_GRADIENT = "var(--sidebar-gradient)";



/** Theme-aware primary references for inline styles. */

export const BLUE_PRIMARY = "var(--primary)";

export const BLUE_SECONDARY = "var(--sidebar-primary)";

